const fetchData = async (url) => {
  try {
    const body = new FormData();
    body.append('ajax_action', 'Y');

    const rawResponse = await fetch(url, {
      method: 'POST',
      body,
    });

    const response = await rawResponse.text();
    return response;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);
    return null;
  }
};

const initScripts = () => {
  window.initComparsion();
  window.initCompareDeleteItemButtons();
  window.initCompareDifferenceTOggler();
};

const deleteItem = async function (element, itemId) {
  const textHTML = await fetchData(`/catalog/compare.php?action_ccr=DELETE_FROM_COMPARE_RESULT&ID=${itemId}`);
  const parentElem = document.getElementById('bx_catalog_compare_block');

  if (textHTML && parentElem) {
    window.deleteCompareItem(itemId);

    const event = new CustomEvent('OnCompareChange');
    element.dispatchEvent(event);

    parentElem.innerHTML = textHTML;
    initScripts();
  }
};

const deleteButtonHandler = async (evt) => {
  window.loaderShow('#bx_catalog_compare_block');

  const target = evt.target.classList.contains('goods-comparsion__card-delete')
    ? evt.target
    : evt.target.closest('.goods-comparsion__card-delete');

  const { attributes } = target;
  const itemId = attributes['data-item-id'].value;

  deleteItem(target, itemId);
};

const init = () => {
  const deleteButtons = document.querySelectorAll('.goods-comparsion__card-delete');

  deleteButtons.forEach((el) => {
    if (!el.classList.contains('_init')) {
      el.addEventListener('click', deleteButtonHandler);
      el.classList.add('_init');
    }
  });
};

init();

window.initCompareDeleteItemButtons = init;
window.deleteItemFromComparePage = deleteItem;
